import React from "react";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import Autosuggest, { ItemAdapter } from 'react-bootstrap-autosuggest';
import { FormControl } from "react-bootstrap";

class ReportsParameterApproverAdapter extends ItemAdapter {
    renderItem(item) {
        return (
            <div className="col-md-12 col-lg-12">
                <div>{item.fullName}</div>
            </div>
        );
    }
}

ReportsParameterApproverAdapter.instance = new ReportsParameterApproverAdapter();

export default class ReportsParameterApprover extends React.Component {
    constructor() {
        super();

        this.state = {
            selectedApprover: '',
            approvers: [],
            message: '',
            approverId: 0
        };

        this.onSearch = this.onSearch.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadReportViewModel = this.loadReportViewModel.bind(this);
    }

    componentDidMount() {
        this.loadReportViewModel();
    }

    componentWillReceiveProps(nextProps) {
        if (parseInt(nextProps.approverid || 0) != this.state.approverId) {
            this.loadReportViewModel(nextProps.approverid);
        }
    }

    loadReportViewModel(approverId) {
        if (this.props.role == 'supervisor') {
            this.onSearch('', null, null, approverId)
        }
    }

    onSearch(search, page, prev, approverId) {
        let self = this;

        if (search === undefined)
            search = '';

        if (approverId === undefined)
            approverId = parseInt(this.props.approverId || 0);

        if (search != '' || this.props.role == 'supervisor') {
            var url = '';
            var topRecords = 10;
            var params = {
                prefix: search.trim(),
                topRecords: topRecords
            };

            if (this.props.role == 'supervisor') {
                url = 'get-people-tree-by-approver';
                topRecords = 0;
                params = {
                    approverId: approverId,
                    includeDelegates: true,
                    includeStaffCount: true,
                    includeApprover: false
                };

                self.setState({
                    approverId: approverId
                });
            }
            else if (this.props.role == 'payroll-admin') {
                url = 'get-approvers-by-ae';
            }

            if (url != '' &&
                (this.props.role == 'payroll-admin' || 
                (this.props.role == 'supervisor' && approverId > 0))) {
                    
                ajax.api().get(url, {
                    params: params
                })
                .then(function (res) {
                    if (res.data.length > 0) {
                        self.setState({
                            approvers: res.data,
                            message: ''
                        });
                    }
                    else {
                        self.setState({
                            approvers: [],
                            message: 'No matching approvers...'
                        });
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                });
            }
        }
        else{
            self.setState({
                approvers: [],
                message: 'Type at least one character'
            });
        }
    }
    
    onChange(value) {
        value = value.trim();

        this.setState({
            selectedApprover: value
        });

        if (this.props.onChange)
            this.props.onChange('', value);    
    }

    onSelect(item) {
        if (!(typeof item === 'string' || item == null) && this.props.onChange)
            this.props.onChange(item.approverId, item.fullName);
    }

    handleChange(event) {
        if (this.props.onChange)
            this.props.onChange(event.target.value, '');
    }

    render() {
       if (this.props.role == 'supervisor') {
            var approverList = [];
            approverList.push(<option key="All" value="" selected="true">All Direct Reports</option>);
            var approvers = this.state.approvers || [];
            
            approvers.map(function (item, i) {
                approverList.push(<option key={item.approveId} value={item.approverId}>{item.lastName + ', ' + item.firstName}</option>)
            }, this);

            return (
                <FormControl
                    id="ApproverSelect"
                    componentClass="select"
                    onChange={this.handleChange.bind(this)}
                    inputRef={el => this.inputEl = el}>
                    {approverList}
                </FormControl>
            );
        }
        else {
            return (
                <Autosuggest
                    datalist={this.state.approvers}
                    datalistPartial
                    datalistMessage={this.state.message}
                    placeholder="Select Approver"
                    value={this.state.selectedApprover}
                    itemAdapter={ReportsParameterApproverAdapter.instance}
                    itemValuePropName="fullName"
                    searchDebounce={500}
                    onSearch={this.onSearch}
                    onChange={this.onChange} 
                    onSelect={this.onSelect} />
            );
        }
    }
}